import { useWidgetStore } from '@/modules/widget/stores/widgetStore'
import { useOfferStore } from '@/modules/offer/stores/offerStore'
import { useFlowStore } from '@/modules/flow/stores/flowStore'
import { useCampaignStore } from '@/modules/personalization/stores/campaignStore'
import { useSegmentGroupStore } from '@/modules/segment/stores/segmentGroupStore'

export function useResourceInfo() {
  const route = useRoute()
  const widgetStore = useWidgetStore()
  const offerStore = useOfferStore()
  const flowStore = useFlowStore()
  const campaignStore = useCampaignStore()
  const segmentGroupStore = useSegmentGroupStore()

  function getResourceInfo(key: string, id: string): { name: string; path: string } | null {
    switch (key) {
      case 'widgetId': {
        const widget = widgetStore.getById(id)
        return widget ? { name: widget.name || 'Unnamed Widget', path: `/widgets/${id}` } : null
      }
      case 'offerId': {
        const offer = offerStore.getById(id)
        return offer ? { name: offer.name || 'Unnamed Offer', path: `/offers/${id}` } : null
      }
      case 'offerFunnelId': {
        const flow = flowStore.getById(id)
        return flow ? { name: flow.name || 'Unnamed Flow', path: `/flows/${id}` } : null
      }
      case 'campaignId': {
        const campaign = campaignStore.getById(id)
        return campaign ? { name: campaign.name || 'Unnamed Campaign', path: `/personalizer/${id}` } : null
      }
      case 'segmentGroupId': {
        const dimension = segmentGroupStore.getById(id)
        return dimension ? { name: dimension.name || 'Unnamed Segment Group', path: `/segments/${id}` } : null
      }
      default:
        return null
    }
  }

  function interpolatePrompt(prompt: string): string {
    return prompt.replace(/\{\{(\w+)\}\}/g, (_, key) => {
      const id = route.params[key] as string
      if (!id) return `{{${key}}}`

      const resourceInfo = getResourceInfo(key, id)
      if (resourceInfo) {
        return `[${resourceInfo.name}](${resourceInfo.path})`
      }

      return id
    })
  }

  return { getResourceInfo, interpolatePrompt }
}
